export default {
    loaded: "vip20.loaded",
    toggleButton: "vip20.toggle.button",
    bonuses: {
        freeplay: "vip20.freeplay",
        birthday_bonus: "vip20.birthday_bonus",
        weekly_rakeback: "vip20.weekly_rakeback",
        monthly_rakeback: "vip20.monthly_rakeback"
    }
}